import { Component, Input, OnChanges } from '@angular/core';
import { Session } from '@models/Sessions/Session';
import { ConfigService } from '@services/config.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'session-card',
  templateUrl: './session-card.component.html',
  styleUrls: ['./session-card.component.scss'],
})
export class SessionCardComponent implements OnChanges {
  @Input() session: Session;
  @Input() newIdea = false;

  permissions: any;

  constructor(
    private appConfig: ConfigService,
    private sessions: SessionsRequestService,
  ) {
    this.permissions = this.appConfig.permissions;
  }

  ngOnChanges() {
    if (this.session && !this.session.config.organizer) {
      this.session.config.organizer = this.appConfig.defaultOrganizer;
    }
  }

  follow() {
    if (!this.session.lockActions) {
      this.session.lockActions = true;
      this.sessions.follow(this.session).subscribe(
        () => {
          this.session.lockActions = false;
          // this.session.data.followers.length;
          this.session.i_follow = true;
        },
        () => {
          this.session.lockActions = false;
        },
      );
    }
  }

  unfollow() {
    if (!this.session.lockActions) {
      this.session.lockActions = true;
      this.sessions.unfollow(this.session).subscribe(
        () => {
          this.session.lockActions = false;
          // this.session.data.followers--;
          this.session.i_follow = false;
        },
        () => {
          this.session.lockActions = false;
        },
      );
    }
  }
}
